import normalize from "json-api-normalizer";
import { get } from "lodash";
import { push } from "connected-react-router";

import DiscountsService from "../services/discounts.service";
import NotificationService from "../services/notification.service";
import { FETCH_SUCCESS, FETCH_FAILED, FETCH_START, ASYNC_START, ASYNC_END } from "./types";
import { setResouceType } from "../reducers/resources.reducer";

const RESOURCE_TYPE = "discounts";

export const fetchDiscounts = () => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch({ type: FETCH_START, payload: {} });

  try {
    const result = await DiscountsService.getAll(tenantSlug);
    const data = normalize(result.data, { endpoint: RESOURCE_TYPE });

    dispatch({
      type: FETCH_SUCCESS,
      payload: data
    });
  } catch (e) {
    dispatch({ type: FETCH_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch discounts. ${NotificationService.handleMessage(e)}`);
  }
};

export const fetchDiscount = id => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch(setResouceType(RESOURCE_TYPE));
  dispatch({ type: FETCH_START, payload: {} });
  try {
    const result = await DiscountsService.get(id, tenantSlug);
    const data = normalize(result.data, { endpoint: RESOURCE_TYPE });

    dispatch({ type: FETCH_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: FETCH_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch discount ${id}. ${NotificationService.handleMessage(e)}`);
  }
};

export const createDiscount = data => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  const prices = data.discount.prices;
  delete data.discount.prices;

  try {
    dispatch({ type: ASYNC_START, payload: { resource: RESOURCE_TYPE } });
    const createDiscountResponse = await DiscountsService.create(tenantSlug, data);

    const discountSlug = get(createDiscountResponse, "data.data.id");

    if (prices) {
      await Promise.all(
        prices.map(price => {
          if (price.id && price.removed) DiscountsService.deletePrice(price.id, tenantSlug);
          else if (price.id && !price.removed) return DiscountsService.updatePrice(price.id, tenantSlug, price);
          else if (!price.id && !price.removed) return DiscountsService.createPrice(discountSlug, tenantSlug, price);
          return Promise.resolve(true);
        })
      );
    }

    dispatch({ type: ASYNC_END });
    dispatch(push("/discounts"));
    NotificationService.addSuccess("Discount successfully created!");
  } catch (e) {
    dispatch({ type: ASYNC_END, payload: { success: false } });
    NotificationService.addError(`Failed creating the discount! ${NotificationService.handleMessage(e)}`);
  }
};

export const updateDiscount = (id, data) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  const prices = data.discount.prices;
  const discountSlug = data.discount.slug;
  delete data.discount.prices;

  try {
    dispatch({ type: ASYNC_START, payload: { resource: RESOURCE_TYPE } });
    await DiscountsService.update(id, tenantSlug, data);

    if (prices) {
      await Promise.all(
        prices.map(price => {
          if (price.id && price.removed) DiscountsService.deletePrice(discountSlug, price.id, tenantSlug);
          else if (price.id && !price.removed)
            return DiscountsService.updatePrice(discountSlug, price.id, tenantSlug, price);
          else if (!price.id && !price.removed) return DiscountsService.createPrice(id, tenantSlug, price);
          return Promise.resolve(true);
        })
      );
    }

    dispatch({ type: ASYNC_END });
    dispatch(push("/discounts"));
    NotificationService.addSuccess("Discount successfully updated!");
  } catch (e) {
    dispatch({ type: ASYNC_END, payload: { success: false } });
    NotificationService.addError(`Failed updating the discount! ${NotificationService.handleMessage(e)}`);
  }
};
